import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
 
const AssemblyInstructions = () => {
    return (
<svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#jnze4nshfa)">
<path
                    d="M17.863 23.5 2.084 39.279C.72 41.05.607 42.553 1.744 43.787c1.707 1.85 3.41 1.052 4.848 0 .016-.012 5.276-5.271 15.779-15.779m1.445-10.456 3.091-3.091c-1.661-3.483-1.796-7.038 1.087-9.922l1.473-1.472C32.042.491 36.205.461 39.387 1.98l-5.504 5.504 4.418 4.416 5.504-5.504c1.518 3.183 1.488 7.346-1.088 9.922l-1.472 1.472c-2.884 2.884-6.44 2.748-9.92 1.088l-2.82 2.818-4.689-4.145zM4.081 41.704l2.208-2.21-2.208 2.21zM28.23 31.14l-16.93-16.931-3.682-.736-5.891-8.83 2.947-2.95 8.834 5.89.736 3.681 16.932 16.931-2.946 2.945zm-2.196 2.22 7.358-7.363c.014-.014 2.21.736 2.21.736s.731 3.677.736 3.682l8.825 8.822a3.123 3.123 0 0 1 0 4.417l-1.473 1.472a3.123 3.123 0 0 1-4.416 0l-8.826-8.825c-.006-.005-3.68-.734-3.68-.734s-.748-2.193-.734-2.207zm6.614-.747 8.833 8.833-8.833-8.833z"
                    stroke="#002856"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
</g>
<defs>
<clipPath id="jnze4nshfa">
<path fill="#fff" d="M0 0h47v47H0z" />
</clipPath>
</defs>
</svg>
    );
};
 
export default AssemblyInstructions;